export default __webpack_public_path__ + "static/media/Investment_Banner.3138187c.png";